import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function Drawer({ open, onClose, title, children }) {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      className="relative z-10"
    >
      {/* <div className="fixed inset-0" /> */}

      <div className="fixed inset-0 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
      <div className="fixed inset-y-2 rounded-lg right-2 flex max-w-full pl-10">
        <DialogPanel
          transition
          className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
        >
          <div className="rounded-r-lg flex h-[calc(100vh-16px)] flex-col bg-white py-6 border">
            <div className="px-4 sm:px-6 flex-shrink-0">
              <div className="flex items-start justify-between">
                <DialogTitle className="text-base font-semibold text-gray-900">
                  {title}
                </DialogTitle>
                <div className="ml-3 flex h-7 items-center">
                  <button
                    type="button"
                    onClick={onClose}
                    className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="absolute -inset-2.5" />
                    <span className="sr-only">Close panel</span>
                    <XMarkIcon
                      aria-hidden="true"
                      className="size-6"
                    />
                  </button>
                </div>
              </div>
            </div>
            {children}
          </div>
        </DialogPanel>
      </div>
      </div>
      </div>
    </Dialog>
  );
}